import { css } from 'lit';
import { registerStyles } from '@vaadin/vaadin-themable-mixin/register-styles.js';
export class VaadinStyleLoader {
    static registerAllStyles() {
        if (VaadinStyleLoader.stylesRegistered) {
            return;
        }
        VaadinStyleLoader.stylesRegistered = true;
        registerStyles('vaadin-details', css `
                :host(.sdb-content-collapsablecard[transparent])
                    [part='summary'] {
                    background-color: transparent;
                }

                :host(.sdb-content-collapsablecard) [part='summary'] {
                    padding: 0;
                    cursor: pointer;
                }

                :host(.sdb-content-collapsablecard) [part='summary-content'] {
                    margin: 1em 0;
                }

                :host(.sdb-content-collapsablecard) [part='toggle'] {
                    margin: 5px;
                }

                :host(.sdb-content-collapsablecard) [part='toggle']::before {
                    font-size: 30px;
                }

                :host(.sdb-content-collapsablecard) [part='summary'],
                :host(.sdb-content-collapsablecard) [part='content'],
                :host(.sdb-content-collapsablecard)
                    [part='summary-content']
                    ::slotted(*) {
                    font-size: 16px;
                    font-family: var(--font-family);
                    color: var(--var-text-primary);
                }
            `);
        registerStyles('vaadin-accordion-panel', css `
                :host(.sdb-content-accordionitem) ::slotted([slot='summary']) {
                    align-items: start;

                    /* vaadin uses !important, so we have to do the same :( */
                    padding: var(--sdb-accordionitem-summary-vertical-padding)
                        0px var(--sdb-accordionitem-summary-vertical-padding)
                        var(--sdb-accordionitem-summary-padding) !important;
                }

                :host(.sdb-content-accordionitem) [part='toggle'] {
                    /*color:var(--btn-tertiary);
      margin: 0;
      cursor:pointer;
      align-self: start;*/
                    display: none;
                }

                :host(.sdb-content-accordionitem)
                    ::slotted([slot='summary']):hover {
                    background-color: var(
                        --sdb-accordion-background-hover,
                        #ffffff
                    );
                }

                :host(.sdb-content-accordionitem) ::slotted([slot='summary']),
                :host(.sdb-content-accordionitem) [part='content'],
                :host(.sdb-content-accordionitem)
                    [part='summary-content']
                    ::slotted(*) {
                    font-size: 16px;
                    font-family: var(--font-family);
                    color: var(--var-text-primary);
                }

                :host(.sdb-content-accordionitem) [part='summary-content'] {
                    display: block;
                    margin: 0;
                }

                :host(.sdb-content-accordionitem[opened]),
                :host(.sdb-content-accordionitem[opened])
                    ::slotted([slot='summary']),
                :host(.sdb-content-accordionitem[opened])[part='content'],
                :host(.sdb-content-accordionitem[opened])
                    [part='summary-content']
                    ::slotted(*) {
                    background-color: var(
                        --sdb-accordion-background-opened,
                        #ffffff
                    );
                    color: var(
                        --sdb-accordion-foreground-opened,
                        --text-primary
                    ) !important;
                }

                :host(.sdb-content-accordionitem:not([opened]))
                    ::slotted([slot='summary'])::after {
                    content: '';
                    display: block;
                    height: 1px;
                    position: relative;
                    top: var(--sdb-accordionitem-summary-vertical-padding);
                    background-color: var(--sdb-accordion-separator);
                    grid-column: span 2;
                }

                :host(.sdb-content-accordionitem[opened]) [part='content'] {
                    background: transparent;
                }
            `);
    }
}
VaadinStyleLoader.stylesRegistered = false;
//# sourceMappingURL=vaadin-style-loader.js.map